import ShipmentDetailModal from 'features/dispatch/components/ShipmentDetailModal/ShipmentDetailModal';
import dispatchApi from 'features/dispatch/dispatch.api';
import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { usePageTitle } from 'utils/locationHelpers';

export default function ShipmentDetailPage() {
    const { shipmentId = '' } = useParams();
    const query = dispatchApi.useShipmentDetailQuery(shipmentId, {
        skip: !shipmentId,
    });
    usePageTitle(query.data?.tuid);

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    return (
        <>
            <ShipmentDetailModal
                model={query.data}
                isLoading={query.isLoading}
                isError={query.isError}
                close={() => navigate(`/shipments?${searchParams}`)}
            />
        </>
    );
}
